// extracted by mini-css-extract-plugin
module.exports = {"domainWarning":"EntityEmailDialog_domainWarning__2aMbQ","red":"EntityEmailDialog_red__1lL6s"};